import React, {ReactNode, useState} from 'react'

import {DashboardProvider} from '../../contexts/DashboardContext'
import Header from './Header'
import {NavigationBar} from './NavigationBar'
import SidebarMenu from './SidebarMenu'
import {DropdownOptionProps, Mode, ProfileMenuItem, SidebarMenuItems} from './types'

export interface Organization {
  name: string;
}

export interface DashboardLayoutProps {
  currentMode?: Mode;
  organization: Organization;
  menuItems: SidebarMenuItems[];
  dropdownOption?: DropdownOptionProps;
  profileMenuItems?: ProfileMenuItem[];
  onLogout: () => void;
  children: ReactNode;
  isAuthenticated?: boolean;
}

const DashboardLayout = ({
  currentMode,
  organization,
  menuItems,
  profileMenuItems,
  dropdownOption,
  onLogout,
  children,
  isAuthenticated = true
}: DashboardLayoutProps) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState<boolean>(false)

  return (
    <DashboardProvider
      currentMode={currentMode || ''}
      organizationName={organization.name}
      menuItems={menuItems}
      profileMenuItems={profileMenuItems}
      onProfileMenuItemClick={onLogout}
      isAuthenticated={isAuthenticated}
    >
      {mobileMenuOpen &&
        <div className="relative z-40 lg:hidden">
          <div className="fixed inset-0 z-40 flex">
            <div className="relative flex flex-col flex-1 w-full bg-kwota-neutral-100">
              <NavigationBar
                mobileMenuOpen={mobileMenuOpen}
                setMobileMenuOpen={() => setMobileMenuOpen(prevOpen => !prevOpen)}
              />
              <SidebarMenu
                dropdownOption={dropdownOption}
                onMenuItemClick={() => setMobileMenuOpen(false)}
              />
            </div>
          </div>
        </div>
      }
      <div className="fixed inset-y-0 hidden lg:flex w-72">
        <SidebarMenu dropdownOption={dropdownOption} />
      </div>
      <div className="min-h-screen bg-kwota-neutral-200 lg:pl-72">
        <NavigationBar
          mobileMenuOpen={mobileMenuOpen}
          setMobileMenuOpen={() => setMobileMenuOpen(prevOpen => !prevOpen)}
        />
        <main className="px-4 pt-24 pb-8 lg:px-10 lg:py-8">
          <Header />
          {children}
        </main>
      </div>
    </DashboardProvider>
  )
}

export default DashboardLayout
